import axios from 'axios'
import { generateToken } from '../utils'
import { TaskID } from '../../components/Tasks/TasksProvider'

export const verifyTaskCompletedStatus = async ({
  contractAddress,
  editSecret,
  invoker,
  chainId,
  taskId,
  isOnchainTask,
  name,
}: {
  contractAddress: string
  editSecret: string
  invoker: string
  chainId: number
  taskId: TaskID
  name: string
  isOnchainTask: boolean
}) => {
  const token = await generateToken(contractAddress, editSecret || '')
  const res = await axios.post(
    `${process.env.REACT_APP_STORAGE_URL}/task/verify`,
    {
      taskId,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        contract: contractAddress,
        invoker,
        chain: chainId,
      },
    }
  )
  return { ...res.data, taskId, isOnchainTask, name }
}
